import React from "react";
import { useSelector } from "react-redux";
import { getUserProfile } from "utils/mapStateToProps";

const UserProfileNav = () => {
  const profile = useSelector((state) => getUserProfile(state));
  return (
    <div className="flex flex-row items-center">
      {profile.img && (
        <div className="br-100" style={{ height: 32 }}>
          <img
            alt="User profile"
            className="br-100"
            style={{
              maxWidth: "100%",
              maxHeight: "100%"
            }}
            src={profile.img}
          />
        </div>
      )}
      {profile.name && (
        <div className={profile.img ? "ml2" : ""}>{profile.name}</div>
      )}
    </div>
  );
};

export default UserProfileNav;
